/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Attendancestats1Inputs */

const de__field_attendancestats1 = /** @type {(inputs: _Field_Attendancestats1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwesenheitensstatistik`)
};

/**

* @param {_Field_Attendancestats1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_attendancestats1 = /** @type {((inputs?: _Field_Attendancestats1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Attendancestats1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_attendancestats1(inputs)
});
export { _field_attendancestats1 as "_field_attendanceStats" }